module.exports = __webpack_public_path__ + "img/promotion-Y.1e12ec54.svg";